import { Observable } from 'rxjs';

export interface ILanguageDirection {
  getDirection(): Observable<string>;
  getRTL(): Observable<boolean>;
  getDirectionFor(language: string): void;
  getRtlFor(language: string): void;
}
